import {TFilterOption} from "../../types/search";
import * as Constants from "../../constants";

export const filters = (filterOptions: TFilterOption[]): string => {
  let fqString: string = '';
  let industries: string[] = [];
  const fqGroups:  { [key: string]: TFilterOption[]; } = {}
  filterOptions.forEach(filter=>{
    const filterCln: TFilterOption = {...filter}
    if (filterCln.field==='collection_facet') {
      if (filterCln.value.indexOf('"') === -1) {
        filterCln.value = "\""+filterCln.value+"\"";
      }

      if (filterCln.industry){
        industries.push(filterCln.industry)
        // all industry collection filter corresponding industry
        //fqString = '&fq=industrycode:' + filterCln.industry;
      }
    }

    if (fqGroups[filter.fq_group]) {
      fqGroups[filter.fq_group].push(filterCln);
    } else {
      fqGroups[filter.fq_group] = [filterCln]
    }
  })

  if (industries.length > 0) {
    let fqIndustries: string = '';
    for (let i=0; i< industries.length; i++) {
      fqIndustries += `(industrycode:${industries[i]})`;
      if (i < industries.length - 1) {
        fqIndustries += ' OR '
      }
    }
    fqString = '&fq=' + fqIndustries;
  }

  let initialGroup: boolean = true;
  for (let fqGroup in fqGroups) {
    initialGroup = true;
    let filterString: string = '';
    let filterAddition: string = '';
    for (let i=0; i<fqGroups[fqGroup].length; i++) {
      const filterOption: TFilterOption = fqGroups[fqGroup][i];

      if ((i > 0) && (fqGroups[fqGroup][i].field !== fqGroups[fqGroup][i-1].field)) {
        if (initialGroup) {
          initialGroup = false;
          filterString = filterAddition;
        } else {
          filterString += ' AND ' + filterAddition;
        }
        filterAddition = '';
      }

      if (filterOption.value === '*') {
        filterAddition += filterOption.field + ':' + filterOption.value;
      } else {
        /* todo: needed for filters with spaces included conflict with display filters */
        if ((filterOption.value && filterOption.value[0] !== ('"')) &&
              (filterOption.fq_group !== Constants.DISPLAY) &&
                (filterOption.fq_group !== Constants.DISPLAY2) &&
                (filterOption.fq_group !== Constants.DISPLAY3)) {
         filterOption.value = '"' + filterOption.value + '"';
        }

        filterAddition += ( ((filterAddition.length > 0) ? ' OR ' : '') + (filterOption.field ? '(' + filterOption.field + ':' : '')  + filterOption.value + (filterOption.field ? ')' : ''));
      }
    }

    if (initialGroup) {
      initialGroup = false;
      filterString = filterAddition;
    } else {
      filterString += ' AND ' + filterAddition;
    }

    if (fqGroup !== 'date') {
      fqString += '&fq=' + encodeURIComponent(filterString)
    }
  }

  return fqString;
}
